import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../../Utils/i18next/i18next";
import { FetchMethodType } from "../../../../../Utils/GlobalVariables/Fetch/MethodsType";

export const onSubmit = async (values, props) => {
  const {
    updateTableRegistry,
    loadData,
    updateSingleRegistry,
    uuid,
  } = props;

  // Autor zapisu i data są ustalane przez serwer (zalogowany technik) - nie wysyłamy ich z UI.
  const data = {
    customerArrangements: values.customerArrangements || null,
    requiresAssignment: Boolean(values.requiresAssignment),
    delayOrder: Boolean(values.delayOrder),
    performRemotelyNow: Boolean(values.performRemotelyNow),
  };

  const { payload } = await GlobalAuthFetch({
    path: `/service/${uuid}/qualification`,
    method: FetchMethodType.patch,
    data,
  });

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    return;
  }

  props.setErrorHeader(0, false);

  NotificationManager.success(i18n.t("global:success"));
  if (loadData) loadData();
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};
